import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

export default () =>
    <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center" flexDirection="column">
      <CircularProgress variant="indeterminate" />
    </Box>